import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { WebsocketRoomsContext } from 'Authenticator';
import PageMessage from '../PageMessage';

const MESSAGE_TIMEOUT = 75000;

const InstallationMonitor = () => {
  const { t } = useTranslation();
  const { messages } = useContext(WebsocketRoomsContext);
  const message = messages['ws.installationAlert'];
  const { start, end } = message || {};
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    if (!message) return undefined;
    setExpired(false);
    const timer = setTimeout(() => setExpired(true), MESSAGE_TIMEOUT);
    return () => clearTimeout(timer);
  }, [message]);

  if (!start || !end || expired) return null;

  return (
    <PageMessage
      iconName="alert"
      iconSize="small"
      title={t('global.installation.title', 'a new version will be installed from {{start}} to {{end}}', {
        start: format(new Date(start), 'HH:mm'),
        end: format(new Date(end), 'HH:mm'),
      })}
      noMargins
      width="fit-content"
      classNamePaper="installation-notification"
    />
  );
};

export default InstallationMonitor;
